import type { SVGProps } from 'react';

export const MoreVert = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 19.275c-.417 0-.775-.142-1.075-.425a1.511 1.511 0 0 1-.425-1.075c0-.417.142-.767.425-1.05.3-.3.658-.45 1.075-.45.417 0 .767.15 1.05.45.3.283.45.633.45 1.05 0 .417-.15.775-.45 1.075a1.426 1.426 0 0 1-1.05.425Zm0-5.775c-.417 0-.775-.142-1.075-.425A1.511 1.511 0 0 1 10.5 12c0-.417.142-.767.425-1.05.3-.3.658-.45 1.075-.45.417 0 .767.15 1.05.45.3.283.45.633.45 1.05 0 .417-.15.775-.45 1.075A1.426 1.426 0 0 1 12 13.5Zm0-5.775c-.417 0-.775-.142-1.075-.425a1.511 1.511 0 0 1-.425-1.075c0-.417.142-.767.425-1.05.3-.3.658-.45 1.075-.45.417 0 .767.15 1.05.45.3.283.45.633.45 1.05 0 .417-.15.775-.45 1.075a1.426 1.426 0 0 1-1.05.425Z" />
    </svg>
  );
};
